export default __webpack_public_path__ + "static/media/website.d90b4436.png";